export default {
  setList (state, payload) {
    state.list = payload
  },

  setEventsList (state, payload) {
    state.eventsList = payload
  },

  newItem (state, payload) {
    state.list.push(payload)
  },

  updateItem (state, payload) {
    const list = [...state.list]
    for (let i = 0; i < list.length; i++) {
      if (list[i].id.toString() === payload.id.toString()) {
        list[i] = Object.assign({}, payload)
      }
    }

    state.list = []
    state.list = [...list]
  },

  deleteItem (state, id) {
    const list = state.list.filter(item => item.id.toString() !== id.toString())
    state.list = []
    state.list = [...list]
  },

  setDefectValue (state, payload) {
    state.defectValue = payload
  },
  toggle () {}
}